import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	environmentLabel: {
		id: 'software-deployments.top-filters.environment-filter.environment-label',
		defaultMessage: 'Environment',
		description: 'Label for environment filter dropdown',
	},
	production: {
		id: 'software-deployments.top-filters.environment-filter.production',
		defaultMessage: 'Production',
		description: 'Group select item label for production environment names',
	},
	staging: {
		id: 'software-deployments.top-filters.environment-filter.staging',
		defaultMessage: 'Staging',
		description: 'Group select item label for staging environment names',
	},
	testing: {
		id: 'software-deployments.top-filters.environment-filter.testing',
		defaultMessage: 'Testing',
		description: 'Group select item label for testing environment names',
	},
	development: {
		id: 'software-deployments.top-filters.environment-filter.development',
		defaultMessage: 'Development',
		description: 'Group select item label for development environment names',
	},
	unmapped: {
		id: 'software-deployments.top-filters.environment-filter.unmapped',
		defaultMessage: 'Unmapped',
		description: 'Group select item label for unmapped environment names',
	},
	maxEnvironmentNamesTooltip: {
		id: 'software-deployments.top-filters.environment-filter.max-environment-names-tooltip',
		defaultMessage: 'Max. number of environments selected',
		description: 'Tooltip shown to user when they attempt to select more than 50 environment names',
	},
});
